import React from "react";
import { SvgIcon } from "@mui/material";
import { ToggleableIconProps } from "@/src/types/IconProps";
import { useTheme } from "@mui/material/styles";
import { getIconColor } from "@/src/services/iconService";

const IconLicencePointsThree = ({ active = false, sx = {} }: ToggleableIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon sx={sx} viewBox="0 0 300 300">
      <g style={{ fill: getIconColor(active, theme) }}>
        <path
          d="M29.485,287.126c-9.121-0.029-16.556-7.465-16.586-16.576V65.91c0-1.906,1.547-3.453,3.455-3.453
			c1.906,0,3.453,1.547,3.453,3.453v204.631c0.018,5.314,4.363,9.662,9.688,9.68h241.006c5.321-0.014,9.672-4.359,9.688-9.689
			V29.462c-0.018-5.32-4.367-9.666-9.697-9.68H29.496c-5.325,0.018-9.672,4.363-9.688,9.689v13.246c0,1.908-1.547,3.455-3.453,3.455
			c-1.908,0-3.455-1.547-3.455-3.455V29.46c0.03-9.117,7.459-16.551,16.563-16.586c0.008,0,0.017,0,0.022,0h241.018
			c9.126,0.021,16.566,7.457,16.598,16.574v241.09c-0.03,9.129-7.472,16.564-16.588,16.588H29.485L29.485,287.126z"
        />
        <path
          d="M159.007,133.48l26.178-38.969h-60.69v13.527h33.938l-25.281,36.479l7.203,6.021
			c14.836-7.35,28.748-0.145,28.748,17.936c0,14.693-10.143,23.492-21.449,23.492c-7.332,0.031-14.209-3.553-18.383-9.582
			l-14.693,6.293c7.906,10.711,20.498,16.951,33.812,16.754c20.287,0.168,36.869-16.141,37.037-36.428
			c0.002-0.191,0.002-0.385,0-0.576C185.472,149.068,175.042,137.904,159.007,133.48z"
        />
      </g>
      <g>
        <path
          fill={theme.palette.primary.main}
          d="M266.124,269.564H33.874c-1.907,0-3.454-1.547-3.454-3.453s1.547-3.455,3.454-3.455H262.67V33.849
			c0-1.908,1.547-3.453,3.454-3.453s3.454,1.545,3.454,3.453v232.262C269.578,268.017,268.03,269.564,266.124,269.564z"
        />
      </g>
    </SvgIcon>
  );
};

export default IconLicencePointsThree;
